<template>
  <div>
    <base-header class="pb-5 pt-5 pt-md-8 bg-vg-gradient">
      <div class="row">
        <div class="col-6 mb-3">
          <el-date-picker class="w-100"
                          v-model="dateRange"
                          type="daterange"
                          range-separator="-"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          start-placeholder="Başlangıç Tarihi"
                          end-placeholder="Bitiş Tarihi">
          </el-date-picker>
        </div>
        <div class="col-6">
          <el-button type="secondary" size="large" class="is-plain"
                     @click="dateFilter">
            <span>Filtrele</span>
          </el-button>
        </div>
      </div>
      <!-- Card stats -->
      <div class="row mt-2">
        <div class="col-xl-3 col-lg-6">
          <stats-card title="Toplam Kullanıcı"
                      cardBg="bg-vg-green"
                      :sub-title="allMembers"
                      icon="ni ni-circle-08"
                      class="mb-4 mb-xl-0"
                      v-loading="count_data_loading">
          </stats-card>
        </div>
        <div class="col-xl-3 col-lg-6">
          <stats-card title="Onaylı Kullanıcı"
                      cardBg="bg-vg-purple"
                      :sub-title="allMembersCount"
                      icon="ni ni-check-bold"
                      class="mb-4 mb-xl-0"
                      v-loading="count_data_loading">
          </stats-card>
        </div>
        <div class="col-xl-3 col-lg-6">
          <stats-card title="İş Başvuru Sayısı"
                      cardBg="bg-vg-yellow"
                      :sub-title="jobApplicantsCount"
                      icon="fa fa-list-alt"
                      class="mb-4 mb-xl-0"
                      v-loading="count_data_loading">
          </stats-card>
        </div>
        <div class="col-xl-3 col-lg-6">
          <stats-card title="İş İlan Sayısı"
                      cardBg="bg-vg-blue"
                      :sub-title="jobsCount"
                      icon="ni ni-paper-diploma"
                      class="mb-4 mb-xl-0"
                      v-loading="count_data_loading">
          </stats-card>
        </div>

      </div>
      <div class="row mt-2">
        <div class="col-xl-3 col-lg-6">
          <stats-card title="Toplam Blog"
                      cardBg="bg-vg-green"
                      :sub-title="blogCount"
                      icon="fa fa-podcast"
                      class="mb-4 mb-xl-0"
                      v-loading="count_data_loading">
          </stats-card>
        </div>

        <div class="col-xl-3 col-lg-6">
          <stats-card title="Toplam Gönderi"
                      cardBg="bg-vg-purple"
                      :sub-title="postCount"
                      icon="fa fa-sticky-note"
                      class="mb-4 mb-xl-0"
                      v-loading="count_data_loading">
          </stats-card>
        </div>
        <div class="col-xl-3 col-lg-6">
          <stats-card title="Staj Başvuru Sayısı"
                      cardBg="bg-vg-yellow"
                      :sub-title="internshipApplicantsCount"
                      icon="fa fa-th-list"
                      class="mb-4 mb-xl-0"
                      v-loading="count_data_loading">
          </stats-card>
        </div>

        <div class="col-xl-3 col-lg-6">
          <stats-card title="Staj İlan Sayısı"
                      cardBg="bg-vg-blue"
                      :sub-title="internshipJobCount"
                      icon="fa fa-graduation-cap"
                      class="mb-4 mb-xl-0"
                      v-loading="count_data_loading">
          </stats-card>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-xl-3 col-lg-6">
          <stats-card title="Toplam Firma"
                      cardBg="bg-vg-green"
                      :sub-title="allCompanyCount"
                      icon="fa fa-suitcase"
                      class="mb-4 mb-xl-0"
                      v-loading="count_data_loading">
          </stats-card>
        </div>
        <div class="col-xl-3 col-lg-6">
          <stats-card title="Onaylı Firma"
                      cardBg="bg-vg-purple"
                      :sub-title="confirmCompanyCount"
                      icon="fa fa-building"
                      class="mb-4 mb-xl-0"
                      v-loading="count_data_loading">
          </stats-card>
        </div>
        <div class="col-xl-3 col-lg-6">
          <stats-card title="Diğer Türlerdeki İlanlara Başvurular"
                      cardBg="bg-vg-yellow"
                      :sub-title="otherApplicants"
                      icon="fa fa-list"
                      class="mb-4 mb-xl-0"
                      v-loading="count_data_loading">
          </stats-card>
          <span style="color: azure; font-size: 0.8rem"> * (Yarı Zamanlı / Diğer / Proje Bazlı / Projeler / Burs Programı / Etkinlik / Teknoloji Kampı / Yarışma)</span>
        </div>


        <div class="col-xl-3 col-lg-6">
          <stats-card title="Toplam Başvuru Sayısı"
                      cardBg="bg-vg-blue"
                      :sub-title="allApplicantsCount"
                      icon="fa fa-th-list"
                      class="mb-4 mb-xl-0"
                      v-loading="count_data_loading">
          </stats-card>
        </div>


      </div>
    </base-header>
    <!--Charts-->
    <div class="container-fluid">
      <div class="row mt-xl-4">
        <div class="col-xl-12 mt-4">
          <card header-classes="bg-transparent">
            <div class="row align-items-center">
              <div class="col-xl-12">
                <p class="font-weight-bold">En Çok Başvuru Alan Firmalar</p>
                <div class="table-responsive" v-loading="company_data_loading">
                  <vue-good-table
                      :columns="companiesColumns"
                      :rows="companies"
                      :paginate="true"
                      :lineNumbers="true"
                      :globalSearch="true"
                      :search-options="{enabled: true,placeholder: 'Ara'}"
                      :sort-options="{enabled:false}"
                      :pagination-options="{
                                enabled: true,
                                mode: 'records',
                                nextLabel: 'İleri',
                                prevLabel: 'Geri',
                                rowsPerPageLabel: 'Sayfa başı sonuç',
                                pageLabel: 'Sayfa',
                                allLabel: 'Hepsi',
                                ofLabel:'Firma',
                                perPage:10
                              }"
                      >
                    <template slot="table-row" slot-scope="props">
                      <button
                          @click="goDetailPage(props.row.id)"
                          v-if="props.column.field == 'id'"
                          class="mr-1 btn btn-sm bg-vg-blue text-white font-weight-normal"
                          plain>
                        Detay
                      </button>
                    </template>
                  </vue-good-table>
                </div>
              </div>
            </div>
          </card>
        </div>
        <div class="col-xl-12 mt-4">
          <card header-classes="bg-transparent">
            <div class="row align-items-center">
              <div class="col-xl-12">
                <p class="font-weight-bold">Üniversite İstatistikleri</p>
                <div class="table-responsive" v-loading="universities_data_loading">
                  <vue-good-table
                      :columns="universitiesColums"
                      :rows="universities"
                      :paginate="true"
                      :lineNumbers="true"
                      :globalSearch="true"
                      :search-options="{enabled: true,placeholder: 'Ara'}"
                      :sort-options="{enabled:false}"
                      :pagination-options="{
                                enabled: true,
                                mode: 'records',
                                nextLabel: 'İleri',
                                prevLabel: 'Geri',
                                rowsPerPageLabel: 'Sayfa başı sonuç',
                                pageLabel: 'Sayfa',
                                allLabel: 'Hepsi',
                                ofLabel:'kişi',
                                perPage:5
                              }"
                      styleClass="table table-bordered table-striped">
                    <template slot="table-row" slot-scope="props">
                      <button
                          @click="goUniversityDetailPage(props.row.id)"
                          v-if="props.column.field == 'id'"
                          class="mr-1 btn btn-sm bg-vg-blue text-white font-weight-normal"
                          plain>
                        Detay
                      </button>
                    </template>
                  </vue-good-table>
                </div>
              </div>
            </div>
          </card>
        </div>
      </div>

      <div class="row mt-xl-4">
        <div class="col-xl-6 mt-4" v-loading="loading">
          <card header-classes="bg-transparent">
            <div class="row align-items-center">
              <div class="col-xl-12">
                <p class="font-weight-bold">Vizyoner Genç Üzerindeki İlanların İlan Tipine Göre Dağılımı</p>
                <pie-chart :chart-data="jobsCollection"></pie-chart>
              </div>
            </div>
          </card>
        </div>
        <div class="col-xl-6 mt-4" v-loading="loading">
          <card header-classes="bg-transparent">
            <div class="row align-items-center">
              <div class="col-xl-12">
                <div class="row">
                  <div class="col-xl-12">
                    <p class="font-weight-bold">Vizyoner Genç Üzerindeki Tüm Başvuruların İlan Tipine Göre Dağılımı</p>
                  </div>
                </div>
                <bar-chart :chart-data="datacollection" class="border rounded p-3 shadow-sm"></bar-chart>
              </div>
            </div>
          </card>
        </div>
      </div>

      <div class="row mt-xl-4">
        <div class="col-xl-6 mt-4">
          <card header-classes="bg-transparent">
            <div class="row align-items-center">
              <div class="col-xl-12">
                <p class="font-weight-bold">Tüm Kullanıcıların Türkiye Bölgelerine Göre Dağılımı</p>
                <div class="table-responsive" v-loading="area_user_count_data_loading">
                  <vue-good-table
                      :columns="areaUserCountColumns"
                      :rows="area_user_count"
                      :paginate="true"
                      :lineNumbers="true"
                      :globalSearch="true"
                      :search-options="{enabled: true,placeholder: 'Ara'}"
                      :sort-options="{enabled:false}"
                      :pagination-options="{
                        enabled: true,
                        mode: 'records',
                        nextLabel: 'İleri',
                        prevLabel: 'Geri',
                        rowsPerPageLabel: 'Sayfa başı sonuç',
                        pageLabel: 'Sayfa',
                        allLabel: 'Hepsi',
                        ofLabel:'kişi',
                        perPage:5
                      }"
                      styleClass="table table-bordered table-striped">
                  </vue-good-table>
                </div>
              </div>
            </div>
          </card>
        </div>
        <div class="col-xl-6 mt-4">
          <card header-classes="bg-transparent">
            <div class="row align-items-center">
              <div class="col-xl-12">
                <p class="font-weight-bold">Tüm Kullanıcıların Yaş Ortalamasına Göre Dağılımı</p>
                <div class="table-responsive" v-loading="age_user_count_data_loading">
                  <vue-good-table
                      compactMode
                      :columns="ageUserCountColumns"
                      :rows="age_user_count"
                      :paginate="true"
                      :lineNumbers="true"
                      :globalSearch="true"
                      :search-options="{enabled: true,placeholder: 'Ara'}"
                      :sort-options="{enabled:false}"
                      :pagination-options="{
                          enabled: true,
                          mode: 'records',
                          nextLabel: 'İleri',
                          prevLabel: 'Geri',
                          rowsPerPageLabel: 'Sayfa başı sonuç',
                          pageLabel: 'Sayfa',
                          allLabel: 'Hepsi',
                          ofLabel:'kişi',
                          perPage:5
                        }"
                      styleClass="table table-bordered table-striped">
                  </vue-good-table>
                </div>
              </div>
            </div>
          </card>
        </div>

      </div>

      <div class="row mt-xl-4">

        <div class="col-xl-6 mt-4">
          <card header-classes="bg-transparent">
            <div class="row align-items-center">
              <div class="col-xl-12">
                <p class="font-weight-bold">Tüm Kullanıcıların Okul Bölümlerine Göre Dağılımı</p>
                <div class="table-responsive" v-loading="section_user_count_data_loading">
                  <vue-good-table
                      :columns="sectionColumns"
                      :rows="section_user_count"
                      :paginate="true"
                      :lineNumbers="true"
                      :globalSearch="true"
                      :search-options="{enabled: true,placeholder: 'Ara'}"
                      :sort-options="{enabled:false}"
                      :pagination-options="{
                          enabled: true,
                          mode: 'records',
                          nextLabel: 'İleri',
                          prevLabel: 'Geri',
                          rowsPerPageLabel: 'Sayfa başı sonuç',
                          pageLabel: 'Sayfa',
                          allLabel: 'Hepsi',
                          ofLabel:'kişi',
                          perPage:5
                        }"
                      styleClass="table table-bordered table-striped">
                  </vue-good-table>
                </div>
              </div>
            </div>
          </card>
        </div>
        <div class="col-xl-6 mt-4">
          <card header-classes="bg-transparent">
            <div class="row align-items-center">
              <div class="col-xl-12">
                <p class="font-weight-bold"> Tüm Kullanıcıların Okul Not Ortalamalarına Göre Dağılımı</p>
                <div class="table-responsive" v-loading="grade_user_count_data_loading">
                  <vue-good-table
                      :columns="gradeUserColumns"
                      :rows="grade_user_count"
                      :paginate="true"
                      :lineNumbers="true"
                      :globalSearch="true"
                      :search-options="{enabled: true,placeholder: 'Ara'}"
                      :sort-options="{enabled:false}"
                      :pagination-options="{
                        enabled: true,
                        mode: 'records',
                        nextLabel: 'İleri',
                        prevLabel: 'Geri',
                        rowsPerPageLabel: 'Sayfa başı sonuç',
                        pageLabel: 'Sayfa',  
                        allLabel: 'Hepsi',
                        ofLabel:'kişi',
                        perPage:5
                      }"
                      styleClass="table table-bordered table-striped">
                  </vue-good-table>

                </div>
              </div>
            </div>
          </card>
        </div>
      </div>

      <div class="row mt-xl-4">
        <div class="col-xl-6 mt-4">
          <card header-classes="bg-transparent">
            <div class="row align-items-center">
              <div class="col-xl-12">
                <p class="font-weight-bold"> Tüm Kullanıcıların Cinsiyetlerine Göre Dağılımı</p>
                <div class="table-responsive" v-loading="gender_user_count_data_loading">
                  <vue-good-table
                      :columns="genderUserColumns"
                      :rows="gender_user_count"
                      :paginate="true"
                      :lineNumbers="true"
                      :globalSearch="true"
                      :search-options="{enabled: true,placeholder: 'Ara'}"
                      :sort-options="{enabled:false}"
                      :pagination-options="{
                        enabled: true,
                        mode: 'records',
                        nextLabel: 'İleri',
                        prevLabel: 'Geri',
                        rowsPerPageLabel: 'Sayfa başı sonuç',
                        pageLabel: 'Sayfa',
                        allLabel: 'Hepsi',
                        ofLabel:'kişi',
                        perPage:2
                      }"
                      styleClass="table table-bordered table-striped">
                    <template slot="table-row" slot-scope="props">
                      <div v-if="props.column.field == 'gender'" class="mr-1" type="primary" size="mini" plain>
                        <span v-if="props.row.gender == 'male'">Kadın</span>
                        <span v-else-if="props.row.gender == null">Belirtmemiş</span>
                        <span v-else>Erkek</span>
                      </div>
                    </template>

                  </vue-good-table>
                </div>
              </div>
            </div>
          </card>
        </div>
        <div class="col-xl-6 mt-4">
          <card header-classes="bg-transparent">
            <div class="row align-items-center">
              <div class="col-xl-12">
                <p class="font-weight-bold">Tüm Kullanıcıların Yüksek Lisans ve Doktora Dağılımı</p>
                <div class="table-responsive" v-loading="school_level_user_count_data_loading">
                  <vue-good-table
                      :columns="schoolColumns"
                      :rows="school_level_user_count"
                      :paginate="true"
                      :lineNumbers="true"
                      :globalSearch="true"
                      :search-options="{enabled: true,placeholder: 'Ara'}"
                      :sort-options="{enabled:false}"
                      :pagination-options="{
                        enabled: true,
                        mode: 'records',
                        nextLabel: 'İleri',
                        prevLabel: 'Geri',
                        rowsPerPageLabel: 'Sayfa başı sonuç',
                        pageLabel: 'Sayfa',  
                        allLabel: 'Hepsi',
                        ofLabel:'kişi',
                        perPage:4
                      }"
                      styleClass="table table-bordered table-striped">
                    <template slot="table-row" slot-scope="props">
                      <div v-if="props.column.field == 'school_level'" class="mr-1" type="primary" size="mini" plain>
                        <span v-if="props.row.school_level == 4">Yüksek Lisans</span>
                        <span v-else>Doktora</span>
                      </div>
                    </template>


                  </vue-good-table>

                </div>
              </div>
            </div>
          </card>
        </div>
      </div>
      <div class="row mt-xl-4">
        <div class="col-xl-6 mt-4">
          <card header-classes="bg-transparent">
            <div class="row align-items-center">
              <div class="col-xl-12">
                <p class="font-weight-bold">Tüm Kulanıcıların Öğrenci- Çalışıyor Bilgileri Dağılımı</p>
                <div class="table-responsive" v-loading="work_user_count_data_loading">
                  <vue-good-table
                      :columns="workColumns"
                      :rows="work_user_count"
                      :paginate="true"
                      :lineNumbers="true"
                      :globalSearch="true"
                      :search-options="{enabled: true,placeholder: 'Ara'}"
                      :sort-options="{enabled:false}"
                      :pagination-options="{
                        enabled: true,
                        mode: 'records',
                        nextLabel: 'İleri',
                        prevLabel: 'Geri',
                        rowsPerPageLabel: 'Sayfa başı sonuç',
                        pageLabel: 'Sayfa',
                        allLabel: 'Hepsi',
                        ofLabel:'kişi',
                        perPage:5 }"
                      styleClass="table table-bordered table-striped">
                  </vue-good-table>
                </div>
              </div>
            </div>
          </card>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import * as axios from "axios";
import VueGoodTable from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
import Vue from 'vue';
import BarChart from "@/components/Charts/BarChart";
import PieChart from "@/components/Charts/PieChart";
// eslint-disable-next-line no-unused-vars
import DoughnutChart from "@/components/Charts/DoughnutChart";
// eslint-disable-next-line no-unused-vars
import LineChart from "@/components/Charts/LineChart";

Vue.use(VueGoodTable);

export default {
  components: {
    BarChart,
    PieChart,

  },
  data() {
    return {
      allCompanyCount: '',
      allMembersCount: '',
      confirmCompanyCount: '',
      unConfirmCompanyCount: '',
      allMembers: '',
      allApplicantsCount: 0,
      internshipApplicantsCount: 0,
      jobApplicantsCount: '',
      allJobCount: '',
      internshipJobCount: '',
      otherJobCount: '',
      normalJobCount: '',
      confirmInternCount: '',
      unConfirmInternCount: '',
      confirmJobCount: '',
      unConfirmJobCount: '',
      internshipCompanyCount: '',
      internAndJobAppCount: '',
      blogCount: '',
      postCount: '',
      otherApplicants: '',
      companies: [],
      universities: [],
      loading: true,
      count_data_loading: true,
      company_data_loading: true,
      age_user_count_data_loading: true,
      area_user_count_data_loading: true,
      gender_user_count_data_loading: true,
      grade_user_count_data_loading: true,
      school_level_user_count_data_loading: true,
      section_user_count_data_loading: true,
      university_count_data_loading: true,
      work_user_count_data_loading: true,
      universities_data_loading: true,
      currentPage: 1,
      currentPageSize: 1,
      dateRange: '',
      age_user_count: '',
      gender_user_count: '',
      grade_user_count: '',
      school_level_user_count: '',
      section_user_count: '',
      university_count: '',
      university_user_count: '',
      work_user_count: '',
      area_user_count: '',
      jobsCount: '',
      companiesColumns: [
        {
          label: 'Firma',
          field: 'name',
          type: 'number',
          html: false,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },
        {
          label: 'Toplam Başvuru Sayısı',
          field: 'toplam_basvuru_sayisi',
          type: 'number',
          html: false,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },
        {
          label: '"Staj" Tipi İlanlara Başvuru Sayısı',
          field: 'staj_tipi_basvuru',
          type: 'number',
          html: false,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },

        {
          label: '"İş" Tipi İlanlara Başvuru Sayısı',
          field: 'is_tipi_basvuru',
          type: 'number',
          html: false,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },
        {
          label: '"Yarı Zamanlı" Tipi İlanlara Başvuru Sayısı',
          field: 'yari_zamanli_tip_basvuru',
          type: 'number',
          html: false,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },
        {
          label: '"Diğer" Tipi İlanlara Başvuru Sayısı',
          field: 'diger_tipinde_basvuru',
          type: 'number',
          html: false,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },

        {
          label: '"Proje Bazlı" Tipi İlanlara Başvuru Sayısı',
          field: 'proje_bazli_tipi_basvuru',
          type: 'number',
          html: false,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },
        {
          label: '"Projeler" Tipi İlanlara Başvuru Sayısı',
          field: 'projeler_tipi_basvuru',
          type: 'number',
          html: false,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },
        {
          label: '"Burs Programı" Tipi İlanlara Başvuru Sayısı',
          field: 'burs_programi_tipi_basvuru',
          type: 'number',
          html: false,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },
        {
          label: '"Etkinlik" Tipi İlanlara Başvuru Sayısı',
          field: 'etkinlik_tipi_basvuru',
          type: 'number',
          html: false,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },
        {
          label: '"Teknoloji Kampı" Tipi İlanlara Başvuru Sayısı',
          field: 'teknoloji_kampi_tipi_basvuru',
          type: 'number',
          html: false,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },
        {
          label: '"Yarışma" Tipi İlanlara Başvuru Sayısı',
          field: 'yarisma_tipi_basvuru',
          type: 'number',
          html: false,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },
        {
          label: 'İşlemler',
          field: 'id',
          type: 'number',
          html: true,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },
      ],
      universitiesColums: [
        {
          label: 'Üniversite',
          field: 'name',
          type: 'number',
          html: false,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },
        {
          label: 'İşlemler',
          field: 'id',
          type: 'number',
          html: true,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },

      ],
      ageUserCountColumns: [
        {
          label: 'Yaş',
          field: 'round((DATEDIFF(NOW(),birth_date)/365))',
          type: 'number',
          html: false,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },
        {
          label: 'Sayı',
          field: 'count(*)',
          type: 'number',
          html: false,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },
      ],
      areaUserCountColumns: [
        {
          label: 'Bölge',
          field: 'Karadeniz Bölgesi',
          type: 'number',
          html: false,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },
        {
          label: 'Sayı',
          field: 'count(*)',
          type: 'number',
          html: false,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },
      ],
      genderUserColumns: [
        {
          label: 'Cinsiyet',
          field: 'gender',
          type: 'number',
          html: false,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },
        {
          label: 'Sayı',
          field: 'count(*)',
          type: 'number',
          html: false,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },
      ],
      gradeUserColumns: [
        {
          label: 'Not Aralığı',
          field: 'Ortalaması 0 ile 1 arasında olanlar',
          type: 'number',
          html: false,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },
        {
          label: 'Sayı',
          field: 'count',
          type: 'number',
          html: false,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },
      ],
      datacollection: null,
      jobsCollection: null,
      infoCollection: null,
      postCollection: null,
      userCollection: null,
      schoolColumns: [
        {
          label: 'Seviye',
          field: 'school_level',
          type: 'number',
          html: false,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },
        {
          label: 'Sayı',
          field: 'count(*)',
          type: 'number',
          html: false,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },
      ],
      sectionColumns: [
        {
          label: 'Bölüm',
          field: 'name',
          type: 'number',
          html: false,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },
        {
          label: 'Sayı',
          field: 'count(*)',
          type: 'number',
          html: false,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },
      ],
      uniUserColumns: [
        {
          label: 'Üniversite',
          field: 'name',
          type: 'number',
          html: false,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },
        {
          label: 'Sayı',
          field: 'count(*)',
          type: 'number',
          html: false,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },
      ],
      uniColumns: [
        {
          label: 'Ad',
          field: 'name',
          type: 'number',
          html: false,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },
      ],
      workColumns: [
        {
          label: 'Çalışma Durumu',
          field: 'Çalışan Sayımız',
          type: 'number',
          html: false,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },
        {
          label: 'Sayı',
          field: 'count',
          type: 'number',
          html: false,
          filterable: true,
          thClass: 'font-weight-bold text-center text-black admin-home-table-head'
        },
      ], rows: [
        {
          btn: '<button>My Action</button>',
        }
      ]

    };
  },
  methods: {
    goDetailPage(id) {
      this.$router.push("admin/company/statistics/" + id);
    },
    goUniversityDetailPage(id) {
      this.$router.push("admin/uni-stat-data/" + id,);
    },
    dateFilter() {
      if (this.dateRange == '') {
        return 0;
      }
      this.getLastCompanies();
    },
    getLastCompanies() {
      var start_date = '';
      var end_date = '';
      if (this.dateRange != '') {
        var dateArray = this.dateRange.toString().split(",");
        start_date = dateArray[0];
        end_date = dateArray[1]
      }
      this.count_data_loading = true;
      axios.get("admin/dashboard/count-data?start_date=" + start_date + "&end_date=" + end_date).then(response => {

        this.allMembers = response.data.count_data[0].count.toString();
        this.allMembersCount = response.data.count_data[1].count.toString();
        this.allCompanyCount = response.data.count_data[2].count.toString();
        this.confirmCompanyCount = response.data.count_data[3].count.toString();
        this.blogCount = response.data.count_data[4].count.toString();
        this.postCount = response.data.count_data[5].count.toString();
        this.internshipApplicantsCount = response.data.job_count_data[0].job_type_11_application_count.toString();
        this.jobsCount = response.data.job_count_data[0].job_type_12_job_count.toString();
        // this.unConfirmCompanyCount = response.data.count_data[10].count.toString();
        this.jobApplicantsCount = response.data.job_count_data[0].job_type_12_application_count.toString();
        this.allApplicantsCount = response.data.job_count_data[0].job_type_11_application_count + response.data.job_count_data[0].job_type_12_application_count + response.data.job_count_data[0].job_type_other_application_count;
        this.allJobCount = response.data.job_count_data[0].total_job_count.toString();
        this.internshipJobCount = response.data.job_count_data[0].job_type_11_job_count.toString();
        this.normalJobCount = response.data.job_count_data[0].job_type_12_job_count.toString();
        this.otherJobCount = response.data.job_count_data[0].job_type_other_job_count.toString();
        this.internAndJobAppCount = response.data.job_count_data[0].job_type_11_application_count + response.data.job_count_data[0].job_type_12_application_count;
        this.otherApplicants = response.data.job_count_data[0].job_type_other_application_count.toString();
        this.count_data_loading = false;
        this.datacollection = {
          labels: ['Toplam Başvuru', 'Staj Başvurusu', 'İş Başvurusu', 'Diğer Başvurular'],
          datasets: [
            {
              label: 'Sayı',
              backgroundColor: '#77b743',
              pointBackgroundColor: 'white',
              borderWidth: 4,
              pointBorderColor: '#249EBF',
              data: [
                parseInt(this.allApplicantsCount),
                parseInt(this.internshipApplicantsCount),
                parseInt(this.jobApplicantsCount),
                parseInt(this.allApplicantsCount - (+this.internshipApplicantsCount + +this.jobApplicantsCount))]
            }
          ]
        }
        this.jobsCollection = {
          datasets: [{
            data: [
              parseInt(this.normalJobCount),
              parseInt(this.internshipJobCount),
              parseInt(this.otherJobCount)
            ],
            backgroundColor: [
              '#77b743',
              '#36a2eb',
              '#f87979',
            ],
            options: {
              plugins: {
                legend: {
                  display: true,
                  labels: {
                    color: 'rgb(255, 99, 132)'
                  }
                }
              }
            },
          }],
          labels: [
            'İş İlanları',
            'Staj İlanları',
            'Diğer İlanlar'
          ]
        }

      })
          .catch(() => {
            this.allMembersCount = "0";
            this.jobsCount = "0";
            this.allCompanyCount = "0";
            this.confirmCompanyCount = "0";
            this.unConfirmCompanyCount = "0";
            this.allMembers = "0";
            this.internshipApplicantsCount = "0";
            this.jobApplicantsCount = "0";
            this.allApplicantsCount = "0";
            this.allJobCount = "0";
            this.internshipJobCount = "0";
            this.normalJobCount = "0";
            this.otherJobCount = "0";
            this.internAndJobAppCount = "0";
            this.otherApplicants = "0";
            this.blogCount = "0";
            this.postCount = "0";
            this.count_data_loading = false;
            this.$notify.error({
              title: 'Bir hata meydana geldi',
              message: ''
            });
          });

      this.company_data_loading = true;
      axios.get("admin/dashboard/company-data?start_date=" + start_date + "&end_date=" + end_date).then(response => {
        this.companies = response.data.company_data;
        this.company_data_loading = false;
      })
          .catch(() => {
            this.company_data_loading = false;
            this.$notify.error({
              title: 'Bir hata meydana geldi',
              message: ''
            });
          });
      this.age_user_count_data_loading = true;
      axios.get("admin/dashboard/age-user-count-data?start_date=" + start_date + "&end_date=" + end_date)
          .then(response => {
            this.age_user_count = response.data.age_user_count;
            this.age_user_count_data_loading = false;
          })
          .catch(() => {
            this.age_user_count_data_loading = false;
            this.$notify.error({
              title: 'Bir hata meydana geldi',
              message: ''
            });
          });
      this.area_user_count_data_loading = true;
      axios.get("admin/dashboard/area-user-count-data?start_date=" + start_date + "&end_date=" + end_date).then(response => {
        this.area_user_count = response.data.area_user_count;
        this.area_user_count_data_loading = false;
      })
          .catch(() => {
            this.area_user_count_data_loading = false;
            this.$notify.error({
              title: 'Bir hata meydana geldi',
              message: ''
            });
          });
      this.gender_user_count_data_loading = true;
      axios.get("admin/dashboard/gender-user-count-data?start_date=" + start_date + "&end_date=" + end_date).then(response => {
        this.gender_user_count = response.data.gender_user_count;
        this.gender_user_count_data_loading = false;
      })
          .catch(() => {
            this.gender_user_count_data_loading = false;
            this.$notify.error({
              title: 'Bir hata meydana geldi',
              message: ''
            });
          });

      this.universities_data_loading = true;
      axios.get("admin/dashboard/get-universities").then(response => {
        this.universities = response.data.universities;
        this.universities_data_loading = false;
      })
          .catch(() => {
            this.universities_data_loading = true;
            this.$notify.error({
              title: 'Üniversiteleri getirirken bir hata meydana geldi',
              message: 'Lütfen sayfayı yenileyiniz. Eğer problem devam ediyorsa yazılım ekibine bildiriniz.'
            });
          });

      this.grade_user_count_data_loading = true;
      axios.get("admin/dashboard/grade-user-count-data?start_date=" + start_date + "&end_date=" + end_date).then(response => {
        this.grade_user_count = [
          {
            "count": response.data.grade_user_count[0].count.toString(),
            "Ortalaması 0 ile 1 arasında olanlar": "Ortalaması 0 ile 1 arasında olanlar"
          },
          {
            "count": response.data.grade_user_count[1].count.toString(),
            "Ortalaması 0 ile 1 arasında olanlar": "Ortalaması 1 ile 2 arasında olanlar"
          },
          {
            "count": response.data.grade_user_count[2].count.toString(),
            "Ortalaması 0 ile 1 arasında olanlar": "Ortalaması 2 ile 3 arasında olanlar"
          },
          {
            "count": response.data.grade_user_count[3].count.toString(),
            "Ortalaması 0 ile 1 arasında olanlar": "Ortalaması 3 ile 4 arasında olanlar"
          }
        ]
        this.grade_user_count_data_loading = false;
      })
          .catch(() => {
            this.grade_user_count_data_loading = false;
            this.$notify.error({
              title: 'Bir hata meydana geldi',
              message: ''
            });
          });
      this.school_level_user_count_data_loading = true;
      axios.get("admin/dashboard/school-level-user-count-data?start_date=" + start_date + "&end_date=" + end_date).then(response => {
        this.school_level_user_count = response.data.school_level_user_count;
        this.school_level_user_count_data_loading = false;
      })
          .catch(() => {
            this.school_level_user_count_data_loading = false;
            this.$notify.error({
              title: 'Bir hata meydana geldi',
              message: ''
            });
          });
      this.section_user_count_data_loading = true;
      axios.get("admin/dashboard/section-user-count-data?start_date=" + start_date + "&end_date=" + end_date).then(response => {
        this.section_user_count = response.data.section_user_count;
        this.section_user_count_data_loading = false;
      })
          .catch(() => {
            this.section_user_count_data_loading = false;
            this.$notify.error({
              title: 'Bir hata meydana geldi',
              message: ''
            });
          });
      this.work_user_count_data_loading = true;
      axios.get("admin/dashboard/work-user-count-data?start_date=" + start_date + "&end_date=" + end_date).then(response => {
        this.work_user_count = response.data.work_user_count;
        this.work_user_count_data_loading = false;
      })
          .catch(() => {
            this.work_user_count_data_loading = false;
            this.$notify.error({
              title: 'Bir hata meydana geldi',
              message: ''
            });
          });
      this.loading = false;
    },

    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5
    }

  },
  mounted() {
    this.getLastCompanies();
  }
};
</script>
<style>
@import "../../assets/css/custom.css";

.line-numbers {
  display: none !important;
}

</style>
